// app/redux/reducers/avanceRequestsReducer.js
import {
    SET_AVANCE_REQUEST_LOADING,
    CLEAR_AVANCE_REQUEST_MESSAGE,

    GET_MY_AVANCE_REQUESTS_SUCCESS,
    GET_MY_AVANCE_REQUESTS_FAIL,

    GET_MY_AVANCES_EN_COURS_SUCCESS,
    GET_MY_AVANCES_EN_COURS_FAIL,

    CREATE_AVANCE_REQUEST_SUCCESS,
    CREATE_AVANCE_REQUEST_FAIL,

    GET_MANAGER_AVANCE_INBOX_SUCCESS,
    GET_MANAGER_AVANCE_INBOX_FAIL,

    MANAGER_AVANCE_DECISION_SUCCESS,
    MANAGER_AVANCE_DECISION_FAIL,

    GET_MANAGER_AVANCE_HISTORY_SUCCESS,
    GET_MANAGER_AVANCE_HISTORY_FAIL,

    GET_ADMIN_AVANCE_INBOX_SUCCESS,
    GET_ADMIN_AVANCE_INBOX_FAIL,

    ADMIN_AVANCE_DECISION_SUCCESS,
    ADMIN_AVANCE_DECISION_FAIL,

    GET_ADMIN_AVANCE_HISTORY_SUCCESS,
    GET_ADMIN_AVANCE_HISTORY_FAIL,

    ENREGISTRER_REMBOURSEMENT_SUCCESS,
    ENREGISTRER_REMBOURSEMENT_FAIL,

    REMBOURSEMENT_ANTICIPE_SUCCESS,
    REMBOURSEMENT_ANTICIPE_FAIL,

    normalizeError,
} from "../actions/avanceRequestActions";

const initialState = {
    myRequests: [],
    myAvancesEnCours: [],
    managerInbox: [],
    managerHistory: [], // ✅ AJOUT
    adminInbox: [],
    adminHistory: [], // ✅ AJOUT
    loading: false,
    error: null,
    message: null,
    success: false,
};

const toStr = (x) => normalizeError(x, "");

export default function avanceRequestsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AVANCE_REQUEST_LOADING:
            return { ...state, loading: !!action.payload };

        case CLEAR_AVANCE_REQUEST_MESSAGE:
            return { ...state, error: "", message: "" };

        // ========= MY REQUESTS =========
        case GET_MY_AVANCE_REQUESTS_SUCCESS:
            return { ...state, myRequests: action.payload || [], error: "" };

        case GET_MY_AVANCE_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MY AVANCES EN COURS =========
        case GET_MY_AVANCES_EN_COURS_SUCCESS:
            return { ...state, myAvancesEnCours: action.payload || [], error: "" };

        case GET_MY_AVANCES_EN_COURS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CREATE =========
        case CREATE_AVANCE_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande d'avance envoyée avec succès",
                error: "",
            };

        case CREATE_AVANCE_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER INBOX =========
        case GET_MANAGER_AVANCE_INBOX_SUCCESS:
            return { ...state, managerInbox: action.payload || [], error: "" };

        case GET_MANAGER_AVANCE_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER DECISION =========
        case MANAGER_AVANCE_DECISION_SUCCESS:
            return { ...state, message: "Décision envoyée", error: "" };

        case MANAGER_AVANCE_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ✅ AJOUT: Manager history
        case GET_MANAGER_AVANCE_HISTORY_SUCCESS:
            return { ...state, managerHistory: action.payload || [], error: "" };

        case GET_MANAGER_AVANCE_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN INBOX =========
        case GET_ADMIN_AVANCE_INBOX_SUCCESS:
            return { ...state, adminInbox: action.payload || [], error: "" };

        case GET_ADMIN_AVANCE_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN DECISION =========
        case ADMIN_AVANCE_DECISION_SUCCESS:
            return { ...state, message: "Décision RH envoyée", error: "" };

        case ADMIN_AVANCE_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN HISTORY =========
        case GET_ADMIN_AVANCE_HISTORY_SUCCESS:
            return { ...state, adminHistory: action.payload || [], error: "" };

        case GET_ADMIN_AVANCE_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= REMBOURSEMENT =========
        case ENREGISTRER_REMBOURSEMENT_SUCCESS:
            return { ...state, message: "Remboursement enregistré", error: "" };

        case ENREGISTRER_REMBOURSEMENT_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= REMBOURSEMENT ANTICIPÉ =========
        case REMBOURSEMENT_ANTICIPE_SUCCESS:
            return { ...state, message: "Remboursement anticipé effectué", error: "" };

        case REMBOURSEMENT_ANTICIPE_FAIL:
            return { ...state, error: toStr(action.payload) };

        default:
            return state;
    }
}